import { ValidationError } from "sequelize"
import {
    CcRequirementStatus,
    CcRequirementStatusCreate,
    CcRequirementStatusSave,
} from "server/models"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import { ASC } from "const"
import {
    CcRequirementStatusList,
    CcRequirementStatusValidation,
} from "./types"


export const GetDefaultStatus = (
    statusList: CcRequirementStatusList,
    statusIds: readonly number[],
) => {
    let defaultStatus: CcRequirementStatus = null
    statusIds.forEach((id) => {
        const status = statusList[id]
        if (status.default) defaultStatus = status
    })

    if (!defaultStatus && statusIds.length) defaultStatus = statusList[statusIds[0]]
    return defaultStatus
}

export const LoadCcRequirementStatuses = (
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementStatus/accountId/${accountId}/projectId/${projectId}`)
    .then((statuses: CcRequirementStatus[]) => {
        const statusList: CcRequirementStatusList = {}
        statuses.forEach((status) => {
            statusList[status.id] = status
        })

        const statusesSorted = statuses.sort((a, b) => sort(a, b, "order", ASC))
        const statusIds: number[] = []
        statusesSorted.forEach((status) => {
            statusIds.push(status.id)
        })

        return { statusList, statusIds }
    })
)

export const LoadCcRequirementStatusById = (
    statusId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementStatus/id/${statusId}/accountId/${accountId}/projectId/${projectId}`)
    .then((status: CcRequirementStatus) => status)
)

export const SaveCcRequirementStatus = (
    id: number,
    status: CcRequirementStatusCreate,
    lang: LangType,
) => {
    const data: CcRequirementStatusSave = {
        id,
        status,
    }
    return POST(
        "/ccRequirementStatus/save",
        JSON.stringify(data),
    ).then((res) => {
        const newStatus = res as CcRequirementStatus
        const error = res as ValidationError
        return {
            newStatusId: newStatus.id || null,
            newStatusOrder: newStatus.order || null,
            validation: <CcRequirementStatusValidation>validate(error, lang),
        }
    })
}

export const DragnDropCcRequirementStatus = (
    statusIds: readonly number[],
    statusList: CcRequirementStatusList,
) => {
    const data: CcRequirementStatus[] = []
    statusIds.forEach((id, index) => {
        data.push({
            ...statusList[id],
            order: index,
        })
    })

    return POST(
        "/ccRequirementStatus/updateMany",
        JSON.stringify(data),
    ).then((success: boolean) => success)
}

export const DeleteCcRequirementStatus = (statusId: number) => (
    DELETE(`/ccRequirementStatus/delete/${statusId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcRequirementStatuses = (
    accountId: number,
    projectId: number,
    defaultStatusesAssigned: boolean,
) => (
    GET(`/ccRequirementStatus/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultStatusesAssigned}`)
    .then((success: boolean) => success)
)
